module.exports = __webpack_public_path__ + "img/lik.6c9bf33c.png";